export const AUDIT_DRAFT_AUTOSAVE_DELAY_MS = 1500;

export const AUDIT_DRAFT_SAVE_STATUS = Object.freeze({
    IDLE: 'idle',
    UNSAVED: 'unsaved',
    SAVING: 'saving',
    SAVED: 'saved',
    ERROR: 'error',
});

export function canAutoSaveAuditDraft({
    canEdit,
    panelType,
    isSaving,
    isComplete,
} = {}) {
    return (
        canEdit === true &&
        panelType !== 'select' &&
        isSaving !== true &&
        isComplete !== true
    );
}

const AUDIT_DRAFT_SAVE_STATUS_META = Object.freeze({
    [AUDIT_DRAFT_SAVE_STATUS.UNSAVED]: {
        label: 'Unsaved changes',
        className: 'text-warning',
        showSpinner: false,
        icon: '⚠',
        variant: 'warning',
    },
    [AUDIT_DRAFT_SAVE_STATUS.SAVING]: {
        label: 'Saving…',
        className: 'text-muted',
        showSpinner: true,
        icon: '●',
        variant: 'muted',
    },
    [AUDIT_DRAFT_SAVE_STATUS.SAVED]: {
        label: 'Saved',
        className: 'text-success',
        showSpinner: false,
        icon: '✓',
        variant: 'success',
    },
    [AUDIT_DRAFT_SAVE_STATUS.ERROR]: {
        label: 'Auto-save failed',
        className: 'text-danger',
        showSpinner: false,
        icon: '✕',
        variant: 'danger',
    },
});

export function getAuditDraftSaveStatusMeta(status) {
    return (
        AUDIT_DRAFT_SAVE_STATUS_META[status] || {
            label: '',
            className: 'text-muted',
            showSpinner: false,
            icon: '',
            variant: 'muted',
        }
    );
}

export function getAuditDraftButtonMeta(
    status,
    { justSaved = false, hasUnsavedChanges = false } = {}
) {
    if (status === AUDIT_DRAFT_SAVE_STATUS.SAVING) {
        return {
            label: 'Saving…',
            disabled: true,
            showSpinner: true,
            title: '',
        };
    }

    if (justSaved) {
        return {
            label: '✓ Saved',
            disabled: true,
            showSpinner: false,
            title: 'All changes saved.',
        };
    }

    if (status === AUDIT_DRAFT_SAVE_STATUS.SAVED && !hasUnsavedChanges) {
        return {
            label: '✓ Saved',
            disabled: true,
            showSpinner: false,
            title: 'All changes saved.',
        };
    }

    if (!hasUnsavedChanges) {
        return {
            label: 'Save draft',
            disabled: true,
            showSpinner: false,
            title: 'No changes to save.',
        };
    }

    return {
        label: 'Save draft',
        disabled: false,
        showSpinner: false,
        title: '',
    };
}
